import BookTradeDelete from './BookTradeDelete'; 

export default BookTradeDelete;